module.exports = __webpack_public_path__ + "static/fonts/open-sans-extrabold.ea12115.woff";